const SupportForm = () => {
  return (
    <div>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLScjvRP1HoMXZWRV2ij7iPNmdf84Qfpii2kZvOh39PYRi498BA/viewform?embedded=true"
        width="100%"
        // height="100v"
        style={{ overflow: "hidden", height: "100vh" }}
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
};

export default SupportForm;
